// Clean URL - Cleans provided URL by removing protocol, www and everything after .com
export default url => {
  if (!url) {
    return;
  }

  return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
};
